module.exports = __webpack_public_path__ + "img/lufthansa.26480538.svg";